import { MessageCircle, Instagram, ShoppingBag, Send } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t border-black/5 mt-24">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-lg mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif', fontWeight: 700 }} data-testid="footer-brand">
              Mid2Mint
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              A sincere, curated PC building service based in Singapore. Every build gets personal attention.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium mb-4" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="footer-quick-links-heading">
              Quick Links
            </h4>
            <ul className="space-y-2.5 text-sm text-muted-foreground">
              <li><a href="/build-choice" className="hover:text-foreground transition-colors" data-testid="footer-builder-link">Build</a></li>
              <li><a href="/custom-build" className="hover:text-foreground transition-colors" data-testid="footer-custom-build-link">Custom Builds</a></li>
              <li><a href="/gallery" className="hover:text-foreground transition-colors" data-testid="footer-gallery-link">Gallery</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium mb-4" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="footer-connect-heading">
              Connect
            </h4>
            <div className="flex gap-3">
              {[
                { href: "https://t.me/stenny24", icon: Send, testid: "footer-telegram-link" },
                { href: "https://wa.me/6597355623", icon: MessageCircle, testid: "footer-whatsapp-link" },
                { href: "https://instagram.com/mid2mint", icon: Instagram, testid: "footer-instagram-link" },
                { href: "https://carousell.app.link/e90VVcbGTZb", icon: ShoppingBag, testid: "footer-carousell-link" }
              ].map(({ href, icon: Icon, testid }) => (
                <a
                  key={testid}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full border border-black/10 flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-black/30 transition-all"
                  data-testid={testid}
                >
                  <Icon className="w-4 h-4" strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-black/5 text-center text-xs text-muted-foreground" data-testid="footer-copyright">
          &copy; 2025 Mid2Mint. Singapore.
        </div>
      </div>
    </footer>
  );
}
